import styled from 'styled-components';
import { AppBar } from '@material-ui/core';

export const StyledHeader = styled(AppBar)`
  && {
    position: fixed;
    width: 100%;
    background-color: #56a7df;
  }
`;